<template>
    <div class="fl-check">
        <div class="container">
            <h2>Проверка физических лиц</h2> 
        </div>
        <div class="container">
            <div class="fl-check-block">
                <div class="input-trio-block">
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Фамилия<span id="asterics">&#42;</span></div>
                        <input
                            id="surname"
                            type="text"
                            placeholder="Фамилия"
                            v-model="lastName"
                            @input="lastName = $event.target.value.replace(/[^а-яa-z-]/gi, '')"
                        />
                    </div>
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Имя<span id="asterics">&#42;</span></div>
                        <input
                            id="name"
                            type="text"
                            placeholder="Имя"
                            v-model="name"
                            @input="name = $event.target.value.replace(/[^а-яa-z-]/gi, '')"
                        />
                    </div>
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Отчество</div>
                        <input
                            id="fatherName"
                            type="text"
                            placeholder="Отчество"
                            v-model="fatherName"
                            @input="fatherName = $event.target.value.replace(/[^а-яa-z-]/gi, '')"
                        />
                    </div>
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Дата рождения<span id="asterics">&#42;</span></div>
                        <input
                            type="text"
                            v-model="birthday"
                            id="birthday"
                            placeholder="31.12.2020"
                            @input="dateFormat($event)"
                            maxlength="10"
                        />
                    </div>
                </div>
                <div class="input-duo-block">
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">ИНН ФЛ</div>
                        <input
                            id="inn"
                            @input="inn = $event.target.value.replace(/[^0-9]/g, '')"
                            v-model="inn"
                            placeholder="ИНН ФЛ"
                            type="text"
                            :maxlength="12"
                        />
                    </div>
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Серия и номер паспорта<span id="asterics">&#42;</span></div>
                        <input
                            id="seria"
                            @input="seria = $event.target.value.replace(/[^0-9]/g, '')"
                            v-model="seria"
                            placeholder="Серия"
                            type="text"
                            :maxlength="4"
                        />
                        <input
                            @input="number = $event.target.value.replace(/[^0-9]/g, '')"
                            id="number"
                            placeholder="Номер"
                            v-model="number"
                            type="text"
                            :maxlength="6"
                        />
                    </div>
                    <div class="form-group form-group_inline form-group_inline-x2">
                        <div class="form-group__header">Дата выдачи</div>
                        <input
                            type="text"
                            id="passportDate"
                            v-model="passportDate"
                            placeholder="31.12.2020"
                            @input="passportDateFormat($event)"
                            maxlength="10"   
                        />
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="form-group">
                <div class="buttons__holder">
                <button id="clear__button" value="Очистить" @click="clearInputs">Очистить</button>
                <button class="form-group__button" value="Поиск" @click="() => sendButtonHandler()">
                    <i v-if="loading" class="lnr lnr-sync rotating" title="Загрузка" style="font-size: 18px; display: inline-block;"></i>
                    <span v-else>Поиск</span>
                </button>
                </div>
            </div>
            <p><span id="asterics">&#42;</span> - поля обязательные к заполнению</p>
        </div>
        <div class="container fz16" v-if="history.list">
            <div style="margin: 60px 0 20px;  color: rgb(30, 139, 195);font-weight: 500;font-size: 32px;">
                <span>История проверок</span>
            </div>
            <adminFilters adminType="check_fl" :onFilterCallback="getList" @admin-request="adminRequest" />
            <dropDownButton title="Скачать в .xlsx" :items="['Первые 5000 записей', 'Текущую страницу']" :onSelect="downloadXLSX" />
            <pagination v-if="history.pagination && history.list.length" :pagination="history.pagination" :onTurnPageCallBack="getList" :showRowsPerPageSelection="false" :rows_on_page="history.list.length"/>
            <table class="content-table" style="width: 100%">
                <tr class="content-table-body-item">
                    <th id="requestNumber">Номер проверки</th>
                    <th id="requestDate">Дата и время проверки</th>
                    <th v-if="admin" id="user">Пользователь</th>
                    <th id="requestStatus">Статус</th>
                    <th id="requestObject">Объект проверки</th>
                </tr>
                <tr v-for="(e,i) in history.list" :key="i" class="content-table-body-item">
                    <td id="numberRequest">
                    <span v-if="e.number_request">{{e.number_request}}</span>
                    </td>
                    <td class="table-column">
                    <span v-if="e.date_request">{{e.date_request}}</span>
                    </td>

                    <td class="table-column" v-if="admin">
                    <span v-if="admin">{{e.user_name}}<br>{{e.user_login ? `(${e.user_login})` : "" }}</span>
                    </td>
                    <td class="table-column">
                    <div id="spinner">
                        <i v-if="e.status==0||e.status==3" class="uk-icon-refresh uk-icon-spin"></i>
                        <i v-if="e.status==1" class="uk-icon-check"></i>
                        <i v-if="e.status==2||e.status>=4||e.status==-1" class="uk-icon-times"></i>
                        <span v-if="e.status==1">{{'выполнено'}}</span>
                        <span v-else-if="e.status==2">{{'нет данных'}}</span>
                        <span v-else-if="e.status==0">{{'в очереди'}}</span>
                        <span v-else-if="e.status==3">{{'в обработке'}}</span>
                        <span class="over-limit" v-else-if="e.status==4">{{'вышло время обработки'}}</span> 
                        <span class="error-message" v-else-if="e.status==-1||e.status>4">{{'ошибка'}}</span>
                        <span class="error-message" v-else-if="e.status==-2">{{'ошибка входных данных'}}</span>
                        <span class="error-message" v-else-if="e.status==-3">{{'выполнение остановлено'}}</span>
                    </div>
                    </td>
                    <td class="table-column">
                    <a
                        target="_blank"
                        v-if="e.id_file"
                        :href="`https://api.1clicom.ru/download/${e.id_file}?sid=${window.apiSession}`"
                    >
                        <span
                        >{{e.param_request.surname}} {{e.param_request.name}} {{e.param_request.patronymic}}</span>
                    </a>
                    <!-- <span v-if="e.param_response.inn_fl&&e.status==1">, {{e.param_request.inn_fl}}</span> -->
                    <span v-if="e.status==1">
                        {{"("+e.param_request.birthday +" г.р"+")"}}
                        <br />
                    </span>
                    <span
                        v-if="e.status==1&&e.param_request.serial_passport!=null&&e.param_request.number_passport!=null"
                    >{{"Паспорт: "+ e.param_request.serial_passport + ' ' + e.param_request.number_passport}}</span>
                        <span v-if="e.param_request.inn_fl&&e.status==1">ИНН: {{e.param_request.inn_fl}}</span>
                    <span v-else-if="e.status==0||e.status==2||e.status==3">
                        {{e.param_request.surname}} {{e.param_request.name}} {{e.param_request.patronymic}}
                        <span v-if="e.param_request.birthday">
                        {{"("+e.param_request.birthday +" г.р"+")"}}
                        <br />
                        </span>
                        
                        <span
                        v-if="e.param_request.serial_passport && e.param_request.number_passport"
                        >Паспорт: {{e.param_request.serial_passport + ' ' + e.param_request.number_passport}}</span>
                        <br/>
                        <span v-if="e.param_request.inn_fl">ИНН: {{e.param_request.inn_fl}}</span>
                    </span>
                        <span @click="updateStatus(e)" v-else-if="e.status==4||e.status==-1"><a class="repeat-request">Повторить проверку</a>
                    <br/>
                        {{e.param_request.surname}} {{e.param_request.name}} {{e.param_request.patronymic}}
                        <span v-if="e.param_request.birthday">
                        {{"("+e.param_request.birthday +" г.р"+")"}}
                        <br />
                        </span>
                        <span
                        v-if="e.param_request.serial_passport && e.param_request.number_passport"
                        >Паспорт: {{e.param_request.serial_passport + ' ' + e.param_request.number_passport}}</span>
                        <br/>
                        <span v-if="e.param_request.inn_fl">ИНН: {{e.param_request.inn_fl}}</span>
                    </span>
                    </td>
                </tr>
            </table>
            <pagination v-if="history.pagination && history.list.length" :pagination="history.pagination" :onTurnPageCallBack="getList" :showRowsPerPageSelection="false" :rows_on_page="history.list.length"/>
        </div>
    </div>
</template>

<style scoped lang="scss">
#group-select {
    width: 390px;
}

#user-select {
    width: 523px;
}

.table-column {
    padding-left: 10px !important;
}

.search-header {
    padding-top: 15px;
    font-size: 14px;
    font-weight: 500;
}

.button-row {
    margin-left:80.4%;
}

.filter-separator {
    padding-top: 3px;
    font-weight: 300;
    color: #b8b8b8;
}

.date-description {
    margin-left: 0 !important;
}

.group-description {
    margin-left: 220px !important;
}

.user-description {
    margin-left: 218px !important;
}

.last-row {
   margin-bottom: 30px !important;
}

.filter-row {
    display: flex;
    margin: 10px 0;
}

.date-filter__holder {
    display: flex;
}

.refresh__button {
    display: inline-block;
    vertical-align: top;
    text-align: center;
    font-weight: 500;
    font-size: 14px;
    color: #333;
    background:transparent;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
    margin-left: 20px;
    width: 112px;
    height: 34px;
    line-height: 34px;
}

.refresh__button:active {
    color: #484747;
    background-color: #a7baf9;
}

#group-filter, #user-filter {
    margin-left: 15px;
}

.filter-table {
    width: 100%;
}

.filter-header {
    padding-top: 8px;
    font-size: 14px;
    font-weight: 500;

}

.filter-description {
    font-size: 14px;
    padding-top: 8px;
    margin: 0 25px;
    font-weight: 400;
}

.type {
    height: 30px !important;
}

.filter-input {
    width: 165px;
    margin-bottom: 5px;
    min-height: 30px;
    border-radius: 3px;
    padding: 4px 8px;
    border: 1px solid #b8b8b8;
    box-shadow: none;
    text-align: left;
}

.fl-check .form-group {
    margin-top: 15px;
    font-size: 14px;
    position: relative;
    margin-right: 15px;
}

.fl-check .form-group__header {
    margin: 2px auto;
    font-weight: 400;
    font-size: 14px;
    height: 27px;
}

.request-select {
    width: 320px;
    border: 1px solid #b8b8b8;
    border-radius: 4px;
    font-size: 14px;
}

.request-select option {
    font-size: 14px;
}

.monitoring__content-search-block {
    width: 100%;
    position: relative;
}

.lnr-cross {
    cursor: pointer;
    position: absolute;
    right: 15px;
    font-size: 26px;
    bottom: 25px;
}

.monitoring__content-search {
    margin-top: 15px;
    margin-bottom: 15px;
    background: rgba(173, 203, 252, 0.46);
    width: 100%;
    height: 46px;
    line-height: 46px;
    border-radius: 6px;
    border: 0;
    padding: 0 20px;
}

h2 {
    display: inline-block;
}

.filters-holder {
    float: right;
    display: block;
    margin: 20px 170px 0 0;
}

.filters-holder button {
    margin: 10px 0 0 0;
}

.repeat-button {
    width: 160px !important;
}

.fl-check {
    padding-top: 46px;
    margin-top: 46px;
    padding-bottom: 50px;
    min-height: calc(100% - (46px + 51px));
    font-family: Gotham Pro, Courier New, Courier, monospace;
}

.container {
    width: 1280px;
    margin: 0 auto;
}

.content-table-body-item th {
    padding: 0 10px;
    white-space: nowrap;
}

.content-table-body-item td {
    padding: 0 10px;
    white-space: nowrap;
}

.container p {
    font-weight: 400;
    font-size: 12px;
    padding-right: 42%;
}

td {
    padding: 10px 0 !important;
    font-weight: 400;
    font-size: 14px;
}

th {
    font-size: 14px;
    font-weight: 500;
    text-align: left;
}

.buttons__holder {
    padding-right: 49.5%;
    text-align: right;
}

.fl-check-block {
    vertical-align: top;
    font-size: 0;
    margin-top: 20px;
    display: inline-block;
}
.input-trio-block {
    display: flex;
    flex-direction: row;
}

.input-duo-block {
    text-align: left;
}

#surname,
#name,
#fatherName {
    width: 160px;
}
#birthday {
    width: 112px;
}

#passportDate {
    width: 112px;
}

#seria {
     width: 131px;
}

#number {
     width: 200px;
}

#inn {
     width: 160px;
}

.fl-check .form-group input[type="text"],
.fl-check .form-group input[type="date"] {
    min-height: 30px;
    border-radius: 3px;
    padding: 4px 8px;
    border: 1px solid #b8b8b8;
    box-shadow: none;
    text-align: left;
}

.fl-check h2 {
    font-size: 44px;
    font-weight: 800;
    font-family: Gotham Pro, Courier New, Courier, monospace;
}

.fl-check .form-group_inline {
    display: inline-block;
    margin-right: 15px;
}

.fl-check .form-group {
    margin-top: 15px;
    font-size: 14px;
    position: relative;
    margin-right: 15px;
}

.fl-check .form-group__header {
    margin: 2px auto;
    font-weight: 400;
    font-size: 14px;
}

.fl-check .form-group__button {
    display: inline-block;
    vertical-align: top;
    width: 112px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    color: #fff;
    font-weight: 500;
    font-size: 14px;
    background-color: #4771f3;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
}

.fl-check .form-group__button:active {
    color: #484747;
    background-color: #a7baf9;
}

#requestNumber {
    white-space: normal;
    width: 60px;
    padding: 0 10px 0 0;
}

#requestDate {
    width: 160px;
}

#requestStatus {
    width: 140px;
}

i {
    line-height: unset;
}

i.uk-icon-refresh {
    color: #005b9b;
}

i.uk-icon-check {
    color: #2ecc71;
}

i.uk-icon-times {
    color: #e74c3c;
}

#numberRequest {
    padding-left: 0;
}

#user {
    width: 180px;
}

#asterics {
    color: #4771f3;
    font-size: 13px;
}

#spinner {
    display: flex;
    padding: 5px 0;
    justify-content: left;
}

#spinner span {
    padding-left: 5px;
}

#clear__button:active {
    color: #484747 !important;
    background-color: #a7baf9 !important;
}

#clear__button {
    display: inline-block;
    vertical-align: top;
    width: 112px;
    height: 34px;
    text-align: center;
    line-height: 34px;
    font-weight: 500;
    font-size: 14px;
    border: 0;
    border-radius: 5px;
    cursor: pointer;
    color: #333;
    background-color: transparent;
}

.error-message{
    padding-left: 8px !important;
}

.over-limit{
    white-space: normal !important;
    padding-left: 10px;
}

.repeat-request{
    color: red;
}

@media screen and (max-width: 767px) {
    .container {
        width: 480px;
    }
}

@media screen and (max-width: 960px) {
    .container {
        width: 767px;
    }
}
@media screen and (max-width: 1280px) {
    .container {
        width: 1024px;
    }
    
    .buttons__holder {
        padding-right: 36.8%;
    }

    #group-select {
        width: 310px;
    }

    #user-select {
        width: 425px;
    }

    .button-row {
        margin-left:75.5%
    }

    .date-description {
        margin-left: 0 !important;
    }

    .group-description {
        margin-left: 140px !important;
    }

    .user-description {
        margin-left: 135px !important;
    }

    .last-row {
        margin-bottom: 30px !important;
    }

    .filter-row {
        display: flex;
        margin: 10px 0;
    }

    #group-filter, #user-filter {
        margin-left: 15px;
    }

    .filter-table {
        width: 100%;
    }

    .filter-header {
        padding-top: 8px;
        font-size: 14px;
        font-weight: 500;

    }

    .filter-description{
        font-size: 14px;
        padding-top: 8px;
        margin: 0 25px;
        font-weight: 400;
    }

    .type {
        height: 30px !important;
    }

    .filter-input {
        width: 125px;
        margin-bottom: 5px;
        min-height: 30px;
        border-radius: 3px;
        padding: 4px 8px;
        border: 1px solid #b8b8b8;
        box-shadow: none;
        text-align: left;
    }

    .request-select {
        width: 334px;
        border: 1px solid #b8b8b8;
        border-radius: 4px;
        font-size: 14px;
    }

}

@media screen and (max-width: 1024px) {
    .container {
        width: 960px;
    }

    .table-column {
        padding-left: 10px !important;
    }

    .search-header {
        padding-top: 15px;
        font-size: 14px;
        font-weight: 500;
    }

    .button-row {
        margin-left:74%
    }

    .filter-separator {
        padding-top: 3px;
        font-weight: 300;
        color: #b8b8b8;
    }

    .date-description {
        margin-left: 60px !important;
    }

    .group-description {
        margin-left: 90px !important;
    }

    .user-description {
        margin-left: 133px !important;
    }

    .last-row {
        margin-bottom: 30px !important;
    }

    .filter-row {
        display: flex;
        margin: 10px 0;
    }

    .date-filter__holder {
        display: flex;
        margin-left: 12%;
    }

    .refresh__button {
        display: inline-block;
        vertical-align: top;
        text-align: center;
        font-weight: 500;
        font-size: 14px;
        color: #333;
        background:transparent;
        border: 0;
        border-radius: 5px;
        cursor: pointer;
        margin-left: 20px;
        width: 112px;
        height: 34px;
        line-height: 34px;
    }

    .refresh__button:active {
        color: #484747;
        background-color: #a7baf9;
    }

    #group-filter, #user-filter {
        margin-left: 15px;
    }

    .filter-table {
        width: 100%;
    }

    .filter-header {
        padding-top: 8px;
        font-size: 14px;
        font-weight: 500;

    }

    .filter-description {
        font-size: 14px;
        padding-top: 8px;
        margin: 0 25px;
        font-weight: 400;
    }

    .type {
        height: 30px !important;
    }

    .filter-input{
        width: 100px;
        margin-bottom: 5px;
        min-height: 30px;
        border-radius: 3px;
        padding: 4px 8px;
        border: 1px solid #b8b8b8;
        box-shadow: none;
        text-align: left;
    }

    .request-select {
        width: 304px;
        border: 1px solid #b8b8b8;
        border-radius: 4px;
        font-size: 14px;
    }

    .monitoring__content-search-block {
        width: 88.5%;
        position: relative;
        margin-left: 70px;
    }
}
</style>

<script>
import tooltip from "@/components/ui/tooltip";
import pagination from '@/components/ui/pagination.vue'
import adminFilters from '@/components/ui/adminFilters.vue'
import { downloadBinaryFile } from '@/helpers'
import dropDownButton from '@/components/ui/dropDownButton.vue'

export default {
    components: {
        tooltip,
        pagination,
        dropDownButton,
        adminFilters
    },
    data() {
        return {
            loading: false,
            timer: "",
            // history.list: [],
            name: "",
            lastName: "",
            fatherName: "",
            inn: "",
            seria: "",
            number: "",
            fileId: "",
            birthday: "",
            passportDate: "",
            statusTimer: "",
            sendRequest: "",
            stringCount: 0,
            history: {
                pagination: {},
                list: [],
                searchQuery: '',
                users: [],
                date_from: '',
                date_to: '',
            },
            checkbox: true
        };
    },
    computed: {
        admin() {
            return this.$store.state.user.groups.filter(e => e.rules.adm_check_fl).length
        }
    },
    mounted() {
        this.getList()
        this.getStatus()
    },
    beforeDestroy() {
        clearInterval(this.statusTimer)
    },
    methods: {
        adminRequest(value){
            this.checkbox = value
        },
        downloadXLSX(item){
            const downloadFileInsideThenFn = res => {
                downloadBinaryFile(res.data, `История запросов ${new Date().toLocaleDateString()}`, 'xlsx')
                this.downloadLoading = false
            }

            let limit, offset

            this.downloadLoading = true

            if(item == 'Первые 5000 записей') {
                limit = 5000
                offset = 0
            } else if(item == 'Текущую страницу') {
                limit = this.history.pagination.rows_per_page
                offset = limit * (this.history.pagination.current_page - 1)
            }

            this.$store.dispatch("RomAPI", {
                method: "verification_fl",
                responseType: 'arraybuffer',
                out_format: "xlsx",
                data: {
                    action: "list",
                    searchName: this.history.searchQuery,
                    filterUsers: this.history.users,
                    dateFrom: this.history.date_from,
                    dateTo: this.history.date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                }
            })
                .then(downloadFileInsideThenFn)
                .finally(this.finishDownload)
        },
        getList(
            offset = 0,
            limit = 50,
            searchQuery = this.history.searchQuery,
            users = this.history.users,
            date_from = this.history.date_from,
            date_to = this.history.date_to
        ) {

            this.loading = true

            this.history = {
                ...this.history,
                searchQuery,
                users,
                date_from,
                date_to
            }

            this.$store.dispatch("RomAPI", {
                method: "verification_fl",
                data: {
                    action: "list",
                    filterUsers: users,
                    searchFIO: searchQuery,
                    dateFrom: date_from,
                    dateTo: date_to,
                    show_adm: this.checkbox,
                    offset,
                    limit
                },
            }).then(e => {
                console.log(e);
                if (e.data.data && e.data.data.list && e.data.data.list.length) {
                    this.history.list = e.data.data.list
                    this.history.pagination = e.data.data.pagination
                    this.history.list.sort((a, b) => {
                        if (a.number_request * 1 < b.number_request * 1) {
                            return 1
                        } else if(a.number_request * 1 > b.number_request * 1) {
                            return -1
                        } else {
                            return 0
                        }
                    })
                } else if(e.data.data.list.length == 0) {
                    this.history.list = []
                    this.history.pagination = {}
                }
            }).finally(() => {
                this.loading = false
            })
        },
        updateStatus(evt){
            if(evt.status == 4 || evt.status == -1){
                this.$store.dispatch("RomAPI",{
                    method: "verification_fl",
                    data: {
                        action: "dropStatus",
                        id_request: evt.id_request
                    },
                }).then(e => {
                    if(e.data.data.code == 0){
                        evt.status = 0
                        this.getStatus()
                    }
                })
            }	
        },
        getStatus() {
            let count = 0
            clearTimeout(this.timer)
            clearInterval(this.statusTimer)
            this.statusTimer = setInterval(() => {
                this.history.list.forEach(element => {
                    if (element.status == 0 || element.status == 3) {
                        this.$store.dispatch("RomAPI", {
                            method: "verification_fl",
                            data: {
                                action: "status",
                                id_request: element.id_request,
                            },
                        }).then(e => {
                            if (e.data.data.status == 1) {
                                element.status = 1
                                element.param_request = e.data.data.param_request
                                element.id_file = e.data.data.id_file
                            } else if (e.data.data.status != 1) {
                                element.status = e.data.data.status
                            }
                        })
                    }
                })
                count++
                console.log("count: " + count)
            }, 10000)
            this.timer = setTimeout(() => {
                clearInterval(this.statusTimer)
                console.log("stop it!")
            }, 600000)
        },
        sendButtonHandler() {
            if (this.seria && this.number && this.name && this.birthday && this.lastName) {
                this.sendInfo()
            } else {
                this.$store.dispatch(
                    "showErrorPopUp",
                    "Заполните все обязательные поля!"
                )
            }
        },
        dateFormat(evt){
            let inputString = evt.target.value
            let result = true
            this.birthday = evt.target.value.replace(/[^0-9.]/g, '')
            if (inputString.length < this.stringCount) {
                this.stringCount = inputString.length
                result = false	
            }
            if (inputString.length === 2 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value	
            }
            if (inputString.length === 5 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.birthday = evt.target.value
            }
            result = true
        },
        passportDateFormat(evt){
            let inputString = evt.target.value;
            let result = true
            this.passportDate = evt.target.value.replace(/[^0-9.]/g, '')

            if (inputString.length < this.stringCount) {
                this.stringCount = inputString.length
                result = false
            }

            if (inputString.length === 2 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.passportDate = evt.target.value	
            }

            if (inputString.length === 5 && result) {
                evt.target.value += '.'
                this.stringCount = inputString.length + 1
                this.passportDate = evt.target.value
            }

            result = true
        },
        sendInfo() {
            this.loading = true
            this.$store.dispatch("RomAPI", {
                method: "verification_fl",
                data: {
                    action: "add",
                    surname: this.lastName,
                    name: this.name,
                    birthday: this.birthday,
                    serial_passport: this.seria,
                    number_passport: this.number,
                    patronymic: this.fatherName,
                    inn_fl: this.inn,
                    date_of_issue: this.passportDate,
                },
            }).then(e => {
                if (e && e.data && e.data.code == 0) {
                    this.getList()
                    this.getStatus()
                }
            }).finally(() => {
                this.loading = false
            })
            this.$store.dispatch(
                "showErrorPopUp",
                "Запрос отправлен!"
            )
            this.clearInputs()
        },
        clearInputs() {
            this.lastName = ""
            this.name = ""
            this.fatherName = ""
            this.inn = ""
            this.seria = ""
            this.number = ""
            this.birthday = ""
            this.passportDate = ""
        }
    }
}
</script>